<template>
    <div class="footer-container">
        <!-- <div class='footer-content'> -->
            <div class='footer-columns'>
                <Column1/>
                <!-- <Column2/>
                <Column3/>
                <Column4/> -->
            </div>
            <div>
                    <div class='sep'></div>
                <BottomSection/>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>

import BottomSection from '@/ecom/components/footer/BottomSection.vue';
import Separator from '@/ecom/components/separators/Separator.vue';
import Column1 from '@/ecom/components/footer/Column1.vue';
import Column2 from '@/ecom/components/footer/Column2.vue';
import Column3 from '@/ecom/components/footer/Column3.vue';
import Column4 from '@/ecom/components/footer/Column4.vue';

export default {
    components: {Column1, Column2, Column3, Column4, BottomSection, Separator},
    data(){
        return{
            year: new Date().getFullYear()
        }
    }
}
</script>
<style lang='scss' scoped>

.footer-container {
    background: var(--footer-background-colour);
	min-height: calc(var(--footer-height) + 20px);
	padding-top: 40px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding-left: 150px;
    padding-right: 150px;
    color: #99A1AF;

    // @media(max-width: 1600px){
    //     padding-left: 200px;
    //     padding-right: 200px;
    // }

    @media(max-width: 1000px){
        padding-left: 100px;
        padding-right: 100px;
    }

    @media(max-width: 768px){
        padding-left: 40px;
        padding-right: 40px;
    }
    // height: 100%;
}

.footer-content{
    display: flex; 
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;

    margin: auto;
    height: 100%;
    flex: 1;
}

.footer-columns{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 40px;
    flex: 1;
    height: 100%;
    max-width: 1600px;

    @media(max-width: 768px){
        flex-direction: column;
    }
}

:deep(){
    .footer-column-links{
        margin-top: 30px;
        display:flex;
        flex-direction: column;
        gap: 8px;
        font-size: 0.855rem;
        max-width: 200px;
    }
}

:deep(){
    .footer-column-title{
    font-size: 1.4rem;
    font-weight: 600;
    min-height: 36px;
    color: var(--primary-colour-2);
    }
}

.separator-small{
    background-color: #e9ecef;
    height: 2px;
    width: 100%;
}

:deep(){
    .footer-link{
        text-decoration: none;
        color: #e9ecef;
        cursor: pointer;
    }
    .footer-link:hover {
        text-decoration: underline;
    }
}

.sep{
    width: 100%;
    height: 1px;
    background-color: #99A1AF;
    opacity: 0.3;
    margin-bottom: 16px;
}

</style>